import SetPasswordContainer from "./SetPasswordContainer";
import SetPasswordStore from "./SetPasswordStore";
export default SetPasswordStore(SetPasswordContainer);
